export const DEFAULT_PLATFORM_TYPE = 'BROWSER';
